import { gql } from "@apollo/client";

export const GET_ALL_PETS = gql`
  query getAllPets {
    getPets {
      pets {
        id,
        name,
        image,
        species,
        speciesName,
        breed,
        gender,
        breedName,
        birthdate,
        isDesexed,
        isEligibleForExpressVisit,
        age,
        socStatus,
        medicalRecord{
          city,
          clinicName,
        },
        medicalRecordsSeenByVet,
        microchip {
          microchipNumber,
          details {
            title,
            description,
          },
        },
        isWellnessplan
      }
    }
  }
`;
